import type { ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';

interface Props {
  title: string;
  count: number;
  children: ReactNode;
}

export function TodoKanbanColumn({ title, count, children }: Props) {
  return (
    <div className="flex flex-col w-80 shrink-0 h-full rounded-lg bg-muted/40 border">
      <div className="flex items-center justify-between px-3 py-2 border-b">
        <span className="text-sm font-semibold">{title}</span>
        <Badge variant="secondary" className="text-xs">{count}</Badge>
      </div>
      <div className="flex-1 p-2 space-y-2 overflow-y-auto min-h-[200px]">
        {children}
      </div>
    </div>
  );
}
